<template>
  <PokerTableSkeleton
    :players="l_players"
    class="table-street-shortcuts"
    tstPrefix="shortcuts_ptabl"
    style="--cards-space: 1rem"
  >
    <template #center>
      <PokerPot
        v-if="potVisible"
        :useNext="false"
        :spot="spot"
        :isVisible="potVisible"
        :hasPot="true"
        :hasStartPot="true"
      >
        <PokerBoard
          :useNext="false"
          :style="'--height: 5em'"
          :cardRowClass="'card-row_btn'"
          :customAnimation="'anim-card-none'"
          :spot="spot"
        />
      </PokerPot>
    </template>

    <template
      v-for="player in l_players"
      #[player.position]
      :key="player.position"
    >
      <slot :name="`${player.position}_before`" />
      <PokerPlayer
        :player="player"
        :hasStack="hasStack"
        :hasCards="hasCards"
        :asCheckbox="asCheckbox"
        @click="$emit('click:player', player)"
      >
        <template #[player.position]>
          <slot :name="player.position" />
        </template>
      </PokerPlayer>
    </template>
  </PokerTableSkeleton>
</template>

<script>
import PokerTableSkeleton from '@/components/PokerTable/PokerTableSkeleton'
import PokerPlayer from '@/components/PokerTable/PokerPlayer'
import PokerBoard from '@/components/PokerTable/PokerBoard'
import PokerPot from '@/components/PokerTable/PokerPot'

export default {
  name: 'PokerTableShortcuts',
  components: {
    PokerPlayer,
    PokerBoard,
    PokerPot,
    PokerTableSkeleton,
  },
  props: {
    // gameformat: Object,
    players: Array,
    spot: Object,
    hasStack: Boolean,
    hasCards: Boolean,
    asCheckbox: { type: Boolean, default: true },
    potVisible: Boolean,
    // playerStyle: String,
  },
  emits: ['click:player'],
  computed: {
    l_players() {
      // if (this.players?.length) {
      return this.players
      // }
      // let gameformat = this.gameformat || this.$store.getters
      // const res = getPlayersDefault({ gameformat })
      // console.log(res)
      // return res
    },
  },
}
</script>
